.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  // Horizontal padding matches the modal header/footer (32px) so the body
  // content lines up with the title + action buttons. Top/bottom sit snug
  // under the sticky header and above the sticky footer.
  padding: 8px 32px 20px;
  min-width: 460px;
}

.origin {
  display: flex;
  align-items: center;
  gap: 8px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.req {
  color: var(--color-destructive, #ef4444);
}
